<div class="profile-picture-wrapper" [style]="{ width: size + 'px' }">
  <ng-content></ng-content>
</div>
